import { Bell, ArrowLeft } from "lucide-react";
import { UserMenu } from "./UserMenu";
import { CreditsDisplay } from "@/components/CreditsDisplay";

interface HeaderProps {
  onReset?: () => void;
  onToggleSidebar?: () => void;
  hasChat?: boolean;
  sidebarOpen?: boolean;
  demoUrl?: string | null;
  showBackButton?: boolean;
  onBackToProjects?: () => void;
  onOpenSettings?: () => void;
  showSettings?: boolean;
}

export const AppHeader = ({
  showBackButton = false,
  onBackToProjects,
}: HeaderProps) => {
  return (
    <header className="h-12 flex items-center justify-between px-4 border-b border-border bg-background">
      {/* Left: back button if needed */}
      <div className="flex items-center gap-3">
        {showBackButton && onBackToProjects && (
          <button
            onClick={onBackToProjects}
            className="p-2 text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
            aria-label="Précédent"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Right: Credits + Notifications + Mon compte */}
      <div className="flex items-center gap-3">
        {/* Credits display */}
        <CreditsDisplay />

        {/* Notifications */}
        <button
          className="p-2 text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
          aria-label="Notifications"
        >
          <Bell className="w-4 h-4" />
        </button>

        {/* UserMenu */}
        <UserMenu />
      </div>
    </header>
  );
};

// Backward compatibility alias
export const V0Header = AppHeader;
